import React from "react";
import { Form } from "react-bootstrap";

interface IProps {
  message?: string;
  when?: boolean;
}

const FormError = (props: IProps) => {
  const { message, when } = props;

  if (!when) {
    return null;
  }

  return (
    <Form.Text className="form-error">
      {message}
    </Form.Text>
  )
}

export default FormError;
